import { Link, useLocation } from "react-router-dom";
const Sidebar = () => {
  const location = useLocation();
  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <>
      <div className="sidebar">
        <div className="sidebar-header">
          <div className="sidebar-logo">
            <Link to="/">
              <img
                src={"/assets/img/logo.png"}
                className="img-fluid logo"
                alt="1"
              />
            </Link>
            <Link to="/">
              <img
                src="/assets/img/logo.png"
                className="img-fluid logo-small"
                alt="2"
              />
            </Link>
          </div>
        </div>
        <div className="sidebar-inner">
          <div id="sidebar-menu" className="sidebar-menu">
            <ul>
              <li className={isActive("/dashboard") ? "active" : ""}>
                <Link to="/dashboard">
                  <i className="fe fe-home text-white"></i>{" "}
                  <span>Dashboard</span>
                </Link>
              </li>
              <li className={isActive("/user-list") ? "active" : ""}>
                <Link to="/user-list">
                  <i className="fe fe-users text-white"></i>{" "}
                  <span>User Management</span>
                </Link>
              </li>
              <li className={isActive("/tile-types") ? "active" : ""}>
                <Link to="/tile-types">
                  <i className="fe fe-grid text-white"></i>{" "}
                  <span>Tile Types</span>
                </Link>
              </li>
              <li className={isActive("/tile-sizes") ? "active" : ""}>
                <Link to="/tile-sizes">
                  <i className="fe fe-maximize text-white"></i>{" "}
                  <span>Tile Sizes</span>
                </Link>
              </li>
              <li className={isActive("/tile-list") ? "active" : ""}>
                <Link to="/tile-list">
                  <i className="fe fe-grid text-white"></i>{" "}
                  <span>Tile Products</span>
                </Link>
              </li>
              <li className={isActive("/sanitaryware-types") ? "active" : ""}>
                <Link to="/sanitaryware-types">
                  <i className="fe fe-droplet text-white"></i>{" "}
                  <span>Sanitaryware Types</span>
                </Link>
              </li>
              <li className={isActive("/sanitaryware-list") ? "active" : ""}>
                <Link to="/sanitaryware-list">
                  <i className="fe fe-package text-white"></i>{" "}
                  <span>Sanitaryware Products</span>
                </Link>
              </li>
              <li
                className={isActive("/sanitaryware-attributes") ? "active" : ""}
              >
                <Link to="/sanitaryware-attributes">
                  <i className="fe fe-tag text-white"></i>{" "}
                  <span>Sanitaryware Attributes</span>
                </Link>
              </li>
              <li className={isActive("/subscription-plans") ? "active" : ""}>
                <Link to="/subscription-plans">
                  <i className="fe fe-credit-card text-white"></i>{" "}
                  <span>Subscription Plans</span>
                </Link>
              </li>
              <li className={isActive("/subscription-list") ? "active" : ""}>
                <Link to="/subscription-list">
                  <i className="fe fe-list text-white"></i>{" "}
                  <span>Subscription List</span>
                </Link>
              </li>
              <li className={isActive("/buyer-inquiry-list") ? "active" : ""}>
                <Link to="/buyer-inquiry-list">
                  <i className="fe fe-users text-white"></i>{" "}
                  <span>Buyer Inquiries</span>
                </Link>
              </li>
              <li
                className={
                  isActive("/sanitaryware-inquiry-click-list") ? "active" : ""
                }
              >
                <Link to="/sanitaryware-inquiry-click-list">
                  <i className="fe fe-check-circle text-white"></i>{" "}
                  <span>Sanitaryware Inquiry Clicks</span>
                </Link>
              </li>

              <li
                className={isActive("/tile-inquiry-click-list") ? "active" : ""}
              >
                <Link to="/tile-inquiry-click-list">
                  <i className="fe fe-target text-white"></i>{" "}
                  <span>Tile Inquiry Clicks</span>
                </Link>
              </li>

              <li className={isActive("/buyer-interests") ? "active" : ""}>
                <Link to="/buyer-interests">
                  <i className="fe fe-heart text-white"></i>{" "}
                  <span>Buyer Interests</span>
                </Link>
              </li>
              <li className={isActive("/banner-management") ? "active" : ""}>
                <Link to="/banner-management">
                  <i className="fe fe-image text-white"></i>{" "}
                  <span>Banner Management</span>
                </Link>
              </li>
              <li className={isActive("/transaction") ? "active" : ""}>
                <Link to="/transaction">
                  <i className="fe fe-credit-card text-white"></i>{" "}
                  <span>Failed Transactions</span>
                </Link>
              </li>
              <li className={isActive("/invoice-list") ? "active" : ""}>
                <Link to="/invoice-list">
                  <i className="fe fe-file-text text-white"></i>{" "}
                  <span>Invoice Management</span>
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
